import { useCallback, useState } from 'react';
import { PER_PAGE } from './contract';

/** Quantidades do "Visualizar por página" das listas (5661). O quadro continua com PER_PAGE. */
export const LIST_PER_PAGE = [25, 50, 100];

// Salva por usuário neste navegador; sem acesso ao storage, a lista volta para 25.
function storageKey() {
  try {
    return `tc-k-list-per-page:${JSON.parse(localStorage.getItem('usuario'))?.id ?? ''}`;
  } catch {
    return 'tc-k-list-per-page:';
  }
}

function stored() {
  try {
    const value = Number(localStorage.getItem(storageKey()));
    return LIST_PER_PAGE.includes(value) ? value : PER_PAGE;
  } catch {
    return PER_PAGE;
  }
}

export default function useListPerPage() {
  const [perPage, setPerPage] = useState(stored);
  const choose = useCallback((value) => {
    if (!LIST_PER_PAGE.includes(value)) return;
    setPerPage(value);
    try {
      localStorage.setItem(storageKey(), String(value));
    } catch {
      // Sem storage, a escolha vale até sair da tela.
    }
  }, []);
  return [perPage, choose];
}
